// extracted by mini-css-extract-plugin
export var carrousselTitle = "styles-module--carrousselTitle--5xDin";
export var image = "styles-module--image--6AWAZ";
export var link = "styles-module--link--7K1zt";
export var linkName = "styles-module--linkName--ZGAhi";
export var swipper = "styles-module--swipper--20+ab";
export var swipperSlide = "styles-module--swipperSlide--n8BFf";